module.exports = __webpack_public_path__ + "static/media/bot.634f3149.png";